import { useNavigate, useLocation } from 'react-router-dom';
import { useUIStore } from '@/stores/uiStore';
import { useMessages } from '@/hooks/useMessages';

export default function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const setActiveSection = useUIStore((s) => s.setActiveSection);
  const { data: messagesData } = useMessages('active');

  const unreadCount =
    messagesData?.messages?.filter((m) => !m.is_read && m.initiated_by === 'agent').length ?? 0;

  const isMessages = location.pathname.startsWith('/app/messages');
  const isSets = location.pathname.startsWith('/app/sets');
  const isTasks = location.pathname.startsWith('/app/tasks');
  const isKit = location.pathname.startsWith('/app/kit');

  return (
    <nav className="flex h-14 items-center justify-around border-t border-neutral-300 bg-primary-10 md:hidden">
      <button
        onClick={() => {
          setActiveSection('messages');
          navigate('/app/messages');
        }}
        className={`relative flex flex-col items-center gap-0.5 px-4 py-1 ${
          isMessages ? 'text-primary-600' : 'text-neutral-500'
        }`}
        aria-label="Messages"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          />
        </svg>
        <span className="text-xs">Chat</span>
        {unreadCount > 0 && (
          <span className="absolute -right-1 top-0 flex h-4 w-4 items-center justify-center rounded-full bg-primary-600 text-[10px] text-black font-bold">
            {unreadCount}
          </span>
        )}
      </button>

      <button
        onClick={() => {
          setActiveSection('sets');
          navigate('/app/sets');
        }}
        className={`flex flex-col items-center gap-0.5 px-4 py-1 ${
          isSets ? 'text-primary-600' : 'text-neutral-500'
        }`}
        aria-label="Sets"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          />
        </svg>
        <span className="text-xs">Sets</span>
      </button>

      <button
        onClick={() => {
          setActiveSection('tasks');
          navigate('/app/tasks');
        }}
        className={`flex flex-col items-center gap-0.5 px-4 py-1 ${
          isTasks ? 'text-primary-600' : 'text-neutral-500'
        }`}
        aria-label="Moves"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
          />
        </svg>
        <span className="text-xs">Moves</span>
      </button>

      <button
        onClick={() => {
          setActiveSection('kit');
          navigate('/app/kit');
        }}
        className={`flex flex-col items-center gap-0.5 px-4 py-1 ${
          isKit ? 'text-primary-600' : 'text-neutral-500'
        }`}
        aria-label="Kit"
      >
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
          />
        </svg>
        <span className="text-xs">Kit</span>
      </button>
    </nav>
  );
}
